import React from "react";
import { PeekStack, PeekTypography } from "@piiqtechnologies/ui-components";
import { Check } from "@piiqtechnologies/svg-icons";
export const ReportTypeList = ({ reportType }) => {
    const highlightedFeatureIndexes = reportType.highlightedFeatureIndexes || [];
    return (React.createElement(PeekStack, { direction: "column", gap: 1, textAlign: "left" },
        React.createElement(PeekTypography, { variant: "body1", fontWeight: "fontWeightMedium", color: "info.main" }, reportType.featuresTitle),
        reportType.features.map((feature, index) => {
            const isHighlighted = highlightedFeatureIndexes.includes(index);
            return (React.createElement(PeekStack, { key: `${reportType.id}-${feature}`, direction: "row", alignItems: "center", gap: 1 },
                React.createElement(PeekTypography, { color: isHighlighted ? "secondary" : undefined, lineHeight: "0" },
                    React.createElement(Check, null)),
                React.createElement(PeekTypography, { variant: "h4", color: isHighlighted ? "secondary" : undefined }, feature)));
        })));
};
export default ReportTypeList;
